import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';



const ActionButton = ({
  loading = false,
  title = 'button',
  onClick,
  size = 'medium',
  icon = null,
  className = 'hp-mr-sm-8 hp-mr-16',
  isActive = false,
  disabled = false,
}) => {
  return (
    <Button
      size={size}
      loading={loading}
      type="primary"
      className={className}
      ghost={!isActive}
      onClick={onClick}
      icon={icon}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

ActionButton.propTypes = {
  title: PropTypes.any,
  icon: PropTypes.element,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.bool,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ActionButton;
